import { buildGroupHierarchy, convertSumWithLatestCurrencyRate, formatCurrency, formatQuantityWithMeasurement, formatShortDate, useEnumLabel } from "../../../../Utils/Utils";
import ActNumberWithAutogenerateInput from "../../../UIElements/Inputs/ActNumberWithAutogenerateInput";
import CalendarInput from "../../../UIElements/Inputs/CalendarInput";
import CurrencyAmountInput from "../../../UIElements/Inputs/CurrencyAmountInput";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import EnumsContext from "../../../../context/enums-context";
import useApi from "../../../../Utils/BackendClient";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import useGetEnums from "../../../../Utils/EnumsUtils";
import { useIsMobile } from "../../../../Utils/ResizeUtils";
import { useLocation, useNavigate } from "react-router-dom";

import ActPayments from "../../../UIElements/ActPayments";
import DocumentArchiveTable from "../../../UIElements/DocumentArchiveTable";
import CommonToolbar from "../../../UIElements/CommonToolbar";
import HistoryElement from "../../../UIElements/HistoryElement";

import { useFormik } from "formik"
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { FloatLabel } from "primereact/floatlabel";
import { Sidebar } from "primereact/sidebar";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { TreeSelect } from "primereact/treeselect";

import commonStyle from "../../CommonStyles.module.css";
import TextInput from "../../../UIElements/Inputs/TextInput";
import { numberEditor } from "../../../../Utils/TableEditors";
import NumberInput from "../../../UIElements/Inputs/NumberInput";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";

const DistributorReturnDetails = () => {

    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef(null);
    const { createDistributorReturnAct, deletePaymentFromAct, fetchActPayments, fetchDistributorReturnActDetails, fetchDistributorReturnActHistory, fetchDistributorReturnActDocuments, fetchProductsExtended, fetchRemainings, updateDistributorReturnAct } = useApi();

    const [actHistory, setActHistory] = useState(null);
    const [actPayments, setActPayments] = useState([]);
    const [docArchive, setDocArchive] = useState(null);
    const [docArchiveTotalRecords, setDocArchiveTotalRecords] = useState(0);
    const [historyTotalRecords, setHistoryTotalRecords] = useState(0);
    const [isEdit, setIsEdit] = useState(false);
    const [isFinalized, setIsFinalized] = useState(false);
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768);
    const [loading, setLoading] = useState(true);
    const [quantitySideBarVisible, setQuantitySidebarVisible] = useState(false);
    const [remainingProducts, setRemainingProducts] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedProductGroup, setSelectedProductGroup] = useState(null);
    const [sortedGroups, setSortedGroups] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);
    const [totaLActSum, setTotalActSum] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [visible, setVisible] = useState(false);
    const [actData, setActData] = useState({
        cagent: null,
        division: null,
        act_number_autogenerate: true,
        act_number: '',
        act_date: new Date(),
        pay_due_date: new Date(),
        status: "Драфт",
        pay_status: "Не оплачено",
        identified_products: [],
        unidentified_products: [],
    });
    const [lazyState, setlazyState] = useState(
        {
            first: 0,
            rows: 20,
            page: 1,
            sortField: "created_at",
            sortOrder: 1,
            filters: {
                division: { value: null, matchMode: 'equals'},
                partner_id: { value: null, matchMode: 'equals' },
                product_group: { value: null, matchMode: 'equals' }
            }
        }
    );
    const [historyLazyState, setHistoryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [docArchiveLazyState, setDocArchiveLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });

    const enumTypes = useMemo(() => ["divisions", "partners", "pay_statuses"], []);

    useGetEnums(enumTypes);

    const getPayStatusLabel = useEnumLabel(ctx.enums.pay_statuses.data);

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const getProductGroups = async () => {
            const response = await fetchProductsExtended();

            if (response.status === 200) {
                const groups = buildGroupHierarchy(response.data);
                setSortedGroups(groups);
            }
            else {
                setSortedGroups([]);
            }
        }

        getProductGroups();
    }, [fetchProductsExtended]);


    const formik = useFormik({
        initialValues: actData,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (values.cagent === null || values.cagent === undefined) {
                errors.cagent = "Виберіть контрагента";
            }

            if (values.division === null || values.division === undefined) {
                errors.division = "Виберіть точку продажу";
            }

            if (!values.act_number_autogenerate) {
                if (values.act_number === null || values.act_number === "") {
                    errors.act_number = "Введіть номер акту";
                }
            }
            return errors;
        },
        onSubmit: async (values) => {

            setSubmitLoading(true);

            const payload = {
                ...values,
                act_date: formatShortDate(values.act_date),
                pay_due_date: formatShortDate(values.pay_due_date),
                act_number: values.act_number === "" ? null : values.act_number
            }

            const response = isEdit ? await updateDistributorReturnAct(values.id, payload) : await createDistributorReturnAct(payload);

            const successStatus = isEdit ? 200 : 201;

            if (response.status === successStatus) {
                const toastMessage = { severity: "success", summary: "Успіх " + (isEdit ? "редагування" : "cтворення"), detail: "Акт успішно " + (isEdit ? "відредаговано" : "створено"), life: 3000 }

                navigate("/distributorreturns", { state: { toast: toastMessage } });
            }
            else{
                DisplayErrors(response.error, toast);
            }

            setSubmitLoading(false);
        }
    });

    useEffect(() => {
        if (location.state !== null) {

            setIsEdit(true);

            const fetchData = async () => {

                const response = await fetchDistributorReturnActDetails(location.state.id);

                if (response.status === 200) {

                    setIsFinalized(response.data.status !== "PENDING");
                    response.data.act_date = new Date(response.data.act_date);
                    response.data.pay_due_date = new Date(response.data.pay_due_date);

                    response.data.identified_products.forEach(element => {
                        element.product_name = element.product;
                        element.product = element.product_id;
                    });

                    response.data.unidentified_products.forEach(element => {
                        element.product_name = element.product;
                        element.product = element.product_id;
                    });

                    setActData(response.data);
                }
            }

            fetchData();
        }
    }, [location.state, fetchDistributorReturnActDetails]);

    useEffect(() => {
        let calcAmount = 0;

        if (formik.values?.unidentified_products?.length > 0) {
            calcAmount += formik.values.unidentified_products.reduce((sum, prod) => sum + convertSumWithLatestCurrencyRate(prod.currency, (prod.quantity ?? 1) * prod.price), 0);
        }

        if (formik.values?.identified_products?.length > 0) {
            calcAmount += formik.values.identified_products.reduce((sum, prod) => sum + convertSumWithLatestCurrencyRate(prod.currency, prod.price), 0);
        }

        setTotalActSum(calcAmount);

    }, [formik.values.identified_products, formik.values.unidentified_products])

    const DeleteFieldHandler = (rowData, fields, name) => {

        const updatedFields = [...fields];

        const index = fields.findIndex(function (field) {
            return field.id === rowData.id && field.price === rowData.price && field.currency === rowData.currency
        });

        updatedFields.splice(index, 1);
        formik.setFieldValue(name, updatedFields);
    };

    const setTableHeader = (tablename) => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                <span className="text-xl text-900 font-bold">{tablename}</span>
            </div>
        );
    }

    const TableFooter = (data) => {

        const totalValue = data.reduce((accumulator, element) => accumulator + element.priceUAH * (element.quantity === undefined ? 1 : element.quantity), 0);

        return (
            <div className={commonStyle.footerContainer}>
                <label>Cума: {formatCurrency(totalValue, "UAH")}</label>
            </div>)
    }

    const UnbindPayment = async (paymentId) => {

        const request = {
            act_id: location.state.id,
            payment_id: paymentId
        }

        const response = await deletePaymentFromAct(request);

        if (response.status === 204) {

            const index = actPayments.findIndex(payment => payment.id === paymentId);
            if (index !== -1) {
                // Create a new array with the element removed
                const newPayments = [...actPayments.slice(0, index), ...actPayments.slice(index + 1)];
                console.log(newPayments);

                // Set the updated state
                setActPayments(newPayments);
            }

            toast.current.show({ severity: "success", summary: "Платіж відвязано", detail: "Платіж відвязано від акту", life: 3000 });

        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка відвязки платежу", detail: "Платіж не відвязано від акту. Код помилки: " + response.status, life: 3000 });
        }
    }

    const getRemainings = async (lazyState) => {

        setLoading(true);

        const response = await fetchRemainings(lazyState);

        if (response.status === 200) {
            setRemainingProducts(response.data.results);
            setTotalRecords(response.data.count);
        }
        else {
            setRemainingProducts([]);
        }

        setLoading(false);

    }

    const applyFilter = async (name, value) => {

        const newLazyState = lazyState;
        newLazyState.filters[name].value = value;
        newLazyState.page = 1;
        newLazyState.first = 0;
        setlazyState(newLazyState);
        
        await getRemainings(newLazyState);
    }

    const SelectPartner = async (id) => {

        formik.setFieldValue("cagent", id);

        const lazyStateToPass = lazyState;
        lazyStateToPass.filters.partner_id.value = id;
        lazyStateToPass.page = 1
        lazyStateToPass.first = 0;
        setlazyState(lazyStateToPass);

        await getRemainings(lazyStateToPass);
    }

    const getActPayments = async (id) => {

        const response = await fetchActPayments(location.state.id);

        if (response.status === 200) {
            setActPayments(response.data.results);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання платежів", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const getActHistory = async (id, state) => {

        const response = await fetchDistributorReturnActHistory(id, state);

        console.log(response);

        if (response.status === 200) {
            setActHistory(response.data.results);
            setHistoryTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання історії", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const items = [
        {
            label: 'Деталі акту повернення',
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            },
        },
        ...(isFinalized
            ? [
                {
                    label: 'Платежі',
                    icon: 'pi pi-money-bill',
                    command: () => {
                        setTabShowed(1);
                        getActPayments(location.state.id);
                    },
                },
            ]
            : []),
        ...(isEdit
            ? [
                {
                    label: 'Історія',
                    icon: 'pi pi-history',
                    command: () => {
                        setTabShowed(2);
                        getActHistory(location.state.id, historyLazyState);
                    },
                },
                {
                    label: 'Документи',
                    icon: 'pi pi-save',
                    command: () => {
                        setTabShowed(3);
                        getDocumentsArchive(location.state.id, historyLazyState);
                    },
                },
            ]
            : []),
    ];

    const onPage = (event) => {
        event.page = event.page + 1;
        setlazyState(event);
    };

    const onHistoryPage = (event) => {
        event.page = event.page + 1;
        getActHistory(location.state.id, event);

        setHistoryLazyState(event);
    }

    const onDocArchivePage = (event) => {
        event.page = event.page + 1;
        getDocumentsArchive(location.state.id, event);

        setDocArchiveLazyState(event);
    }

    const AddProductHandler = () => {
        if (isEdit) {
            SelectPartner(formik.values.cagent);
        }

        setVisible(true);
    }

    const AddProductToTableHandler = (rowData) => {

        console.log(rowData);

        if (rowData.identifier === undefined && rowData.total_quantity > 1) {
            setQuantitySidebarVisible(true);
            setSelectedProduct(rowData);
        }
        else {
            AddProductToAct(rowData);
        }
    }

    const AddProductToAct = (rowData) => {

        if (rowData.identifier !== undefined && rowData.identifier !== null) {
            if (!formik.values.identified_products.some(obj => obj.identifier === rowData.identifier)) {

                let newobject = formik.values.identified_products;
                rowData.remaining_id = rowData.id;
                rowData.price = rowData.last_income_price;
                rowData.currency = rowData.last_income_currency;
                rowData.priceUAH = convertSumWithLatestCurrencyRate(rowData.last_income_currency, rowData.last_income_price);
                newobject = [...newobject, rowData];
                formik.setFieldValue("identified_products", newobject);
            }
            else {
                toast.current.show({ severity: "error", summary: "Помилка додавання", detail: `Товар ${rowData.product_name} (ID:${rowData.identifier}) уже додано`, life: 3000 });
            }
        }
        else {

            let newobject = formik.values.unidentified_products;
            const index = formik.values.unidentified_products.findIndex(x => x.remaining_id === rowData.id);

            if (index >= 0 && newobject[index].price === rowData.price && newobject[index].currency === rowData.currency) {
                newobject[index].quantity = +newobject[index].quantity + +rowData.total_quantity;
                newobject[index].priceUAH = convertSumWithLatestCurrencyRate(newobject.currency, newobject[index].price);
            }
            else {
                console.log(rowData.total_quantity);
                rowData.quantity = rowData.total_quantity;
                rowData.remaining_id = rowData.id;
                delete rowData.id;
                rowData.priceUAH = convertSumWithLatestCurrencyRate(rowData.currency, rowData.price)

                newobject = [...newobject, rowData]
            }
            ;
            formik.setFieldValue("unidentified_products", newobject);
        }

        setQuantitySidebarVisible(false);
    }

    const setSelectedProductQuantity = (amount) => {

        setSelectedProduct(prevProduct => ({
            ...prevProduct,
            total_quantity: amount
        }));
    }

    const setSelectedProductPrice = (insertedPrice) => {

        setSelectedProduct(prevProduct => ({
            ...prevProduct,
            price: +insertedPrice
        }));
    }

    const setSelectedProductCurrency = (insertedCurrency) => {

        setSelectedProduct(prevProduct => ({
            ...prevProduct,
            currency: insertedCurrency
        }));
    }

    const handleCellEditComplete = (e, arrayName) => {
        const rowIndex = e.index ?? e.rowIndex;

        const updated = [...formik.values[arrayName]];
        updated[rowIndex] = {
            ...updated[rowIndex],
            [e.field]: e.newValue
        };

        formik.setFieldValue(arrayName, updated);
    };

    const getDocumentsArchive = async (id, lazyState) => {

        const response = await fetchDistributorReturnActDocuments(id, lazyState);

        if (response.status === 200) {
            setDocArchive(response.data.results);
            setDocArchiveTotalRecords(response.data.count);
        }
    }

    const toolbarLeftData = () => {

        let name = "Створення нового акту повернення постачальнику";

        if (isEdit) {
            name = "Редагування акту повернення постачальнику"

            if (isFinalized) {
                name = "Інформація про акт повернення постачальнику"
            }
        }

        return !isMobile ? <h3>{name}</h3> : null;
    }


    const contentToolbarRightTemplate = () => {
        return (<>
            <div className="flex flex-wrap gap-2">
                <Button label="+Додати товар" severity="success" className={commonStyle.addButton} type="button" onClick={AddProductHandler} />
            </div>
        </>);
    }

    const tableActionBodyTemplate = (rowData) => {

        var isId = Object.hasOwn(rowData, 'identifier');

        return (<div className="flex flex-wrap gap-2">
            {!isFinalized && <Button
                icon="pi pi-trash"
                type="button"
                className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                tooltip="Видалити з таблиці"
                tooltipOptions={{ showOnDisabled: true }}
                onClick={() => DeleteFieldHandler(rowData, isId ? formik.values.identified_products : formik.values.unidentified_products, isId ? "identified_products" : "unidentified_products")}
            />}
        </div>
        );
    };

    const confirmLeave = (event) => {

        if (formik.values !== actData) {

            confirmDialog({
                group: 'headless',
                header: 'Незбережені зміни',
                message: 'У вас є незбережені зміни. Ви впевнені, що хочете залишити цю сторінку?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Так",
                rejectLabel: "Hi",
                defaultFocus: 'accept',
                accept: () => { navigate("/distributorreturns", { state: { pageState: location?.state?.pageState } }) }
            });

        }
        else {
            navigate("/distributorreturns", { state: { pageState: location?.state?.pageState } });
        }
    }

    const actionBodyTemplate = (rowData) => {

        const allItemsAreBooked = rowData.total_quantity === rowData.booked;

        return (<div className="flex flex-wrap gap-2">
            <Button
                icon="pi pi-plus"
                type="button"
                className={`p-button-rounded ${allItemsAreBooked ? commonStyle.closeButton : commonStyle.addButton}`}
                disabled={allItemsAreBooked}
                tooltip={allItemsAreBooked ? "Товар використано в акті" : "Додати"}
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => AddProductToTableHandler(rowData)}
            />
        </div>
        );
    };
    
    return (<form onSubmit={formik.handleSubmit}>
        <Toast ref={toast} />
        <CommonToolbar isMobile={isMobile} isFinalized={isFinalized} loading={submitLoading} onRetunButtonClick={(event) => confirmLeave(event)} leftContent={toolbarLeftData()} />
        <TabMenu model={items} />
        <ConfirmDialog group="headless" />
        {tabShowed === 0 && <div className="grid">
            <div className={`${commonStyle.leftMenu} col-3`}>
                <DropdownInput 
                    formik={formik}
                    paramName="cagent"
                    context={ctx.enums.partners.data}
                    onChange={(val) => formik.setFieldValue("cagent", val)}
                    label="Контрагент"
                    isDisabled={isFinalized || formik.values.identified_products.length > 0 || formik.values.unidentified_products.length > 0}
                    isMobile={isMobile} />
                <DropdownInput 
                    formik={formik}
                    paramName="division"
                    context={ctx.enums.divisions.data}
                    onChange={(val) => formik.setFieldValue("division", val)}
                    label="Точка продажу"
                    isDisabled={isFinalized}
                    isMobile={isMobile}
                    mandatory />
                <CalendarInput formik={formik} paramName="act_date" label="Дата акту" isDisabled={isFinalized} isMobile={isMobile} />
                <CalendarInput formik={formik} paramName="pay_due_date" label="Очікувана дата оплати" isDisabled={isFinalized} isMobile={isMobile} />
                <ActNumberWithAutogenerateInput formik={formik} showAutogenerate={!isFinalized} isDisabled={isFinalized} />
                <TextInput formik={formik} paramName="status" value={formik.values.status === "FINALIZED" ? "Фіналізований" : "Драфт"} label="Статус" isDisabled />
                {isFinalized && <TextInput formik={formik} paramName="pay_status" value={getPayStatusLabel(formik.values.pay_status)} label="Статус оплати" isDisabled />}
            </div>
            <div className="col-9">
                {!isFinalized && <Toolbar className="mb-4" end={contentToolbarRightTemplate} />}
                {(formik.values.identified_products.length > 0) && <DataTable value={formik.values.identified_products} header={setTableHeader("Товари індивідуального обліку")}
                    footer={() => TableFooter(formik.values.identified_products)} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="product_name" header="Продукт" style={{ width: '25%' }} />
                    <Column field="note" header="Примітка" style={{ width: '20%' }} />
                    <Column field="identifier" header="Ідентифікатор" style={{ width: '15%' }} />
                    <Column field="price" header="Ціна в валюті розрахунку" body={rowData => formatCurrency(rowData.price, rowData.currency)} style={{ width: '10%' }} />
                    <Column field="priceUAH" header="Ціна, грн" body={rowData => formatCurrency(rowData.priceUAH, "UAH")} style={{ width: '10%' }} />
                    <Column field="action" body={tableActionBodyTemplate} style={{ width: '20%' }} />
                </DataTable>}
                {(formik.values.unidentified_products.length > 0) && <DataTable value={formik.values.unidentified_products} header={setTableHeader("Товари поштучного обліку")}
                    editMode="cell" footer={() => TableFooter(formik.values.unidentified_products)} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="product_name" header="Продукт" style={{ width: '25%' }}></Column>
                    <Column field="note" header="Примітка" style={{ width: '20%' }} />
                    <Column field="quantity" header="Кількість" 
                        editor={(options) => numberEditor(options, options.rowData.measurement_units === "PIECES" ? 0 : 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "unidentified_products")}
                        body={(rowData) => formatQuantityWithMeasurement(rowData.quantity, rowData.measurement_units)} style={{ width: '15%' }}/>
                    <Column field="price" header="Ціна в валюті розрахунку" body={rowData => formatCurrency(rowData.price, rowData.currency)} style={{ width: '10%' }}/>
                    <Column field="priceUAH" header="Ціна в гривні" body={(rowData => formatCurrency(rowData.priceUAH, "UAH"))} style={{ width: '10%' }}></Column>
                    <Column field="action" body={tableActionBodyTemplate} style={{ width: '20%' }} />
                </DataTable>}
                {(formik.values.unidentified_products.length > 0 || formik.values.identified_products.length > 0) && <div className={commonStyle.footerContainer}>
                    <h3>Загальна сума акту: {formatCurrency(totaLActSum, "UAH")}</h3>
                </div>}
            </div>
        </div>}
        {tabShowed === 1 && isFinalized && <ActPayments isMobile={isMobile} payments={actPayments} onUnbindClick={UnbindPayment} />}
        {tabShowed === 2 && <HistoryElement data={actHistory} lazyState={historyLazyState} totalRecords={historyTotalRecords} onHistoryPage={onHistoryPage} isAct={true} />}
        {tabShowed === 3 && <DocumentArchiveTable documents={docArchive} lazyState={docArchiveLazyState} onPage={onDocArchivePage} totalRecords={docArchiveTotalRecords} toast={toast} />}
        <Sidebar visible={visible} position="right" className={`${commonStyle.shortSideBar} ${quantitySideBarVisible && isLargeScreen ? commonStyle.moveLeft : ''}`} onHide={() => setVisible(false)}>
            <div className={commonStyle.sideBarInput}>
                {formik.values.division === null && <label>Виберіть точку продажу для вибору товару</label>}
                {formik.values.division && formik.values.cagent === null && <label>Виберіть постачальника для вибору товарів</label>}
                <DropdownInput
                    paramName="division"
                    formik={formik}
                    context={ctx.enums.divisions.data}
                    onChange={(val) => {
                        formik.setFieldValue("division", val);
                        applyFilter("division", val); 
                    }}
                    label={"Точка продажу"}
                    customStyle="w-full" 
                />
                {formik.values.division && <>
                    <DropdownInput
                        paramName="cagent"
                        formik={formik}
                        context={ctx.enums.partners.data}
                        onChange={(val) => {
                            formik.setFieldValue("cagent", val);
                            applyFilter("partner_id", val);
                        }}
                        label={"Постачальник"}
                        disabled={formik.values.identified_products.length > 0 || formik.values.unidentified_products.length > 0}
                        customStyle="w-full"
                    />
                    <div className="p-inputgroup flex-column mt-4">
                        <FloatLabel>
                            <TreeSelect
                                name="product_group"
                                value={selectedProductGroup}
                                onChange={(val) => {
                                    setSelectedProductGroup(val.value);
                                    applyFilter("product_group", val.value);
                                }}
                                disabled={formik.values.cagent === null}
                                options={sortedGroups}
                                showClear
                            />
                            <label>Назва групи</label>
                        </FloatLabel>
                    </div>
                </>}
                {formik.values.cagent !== null && <DataTable value={remainingProducts} header="Товари" lazy className="mt-3" emptyMessage="Товари в залишках знайдено"
                    rows={lazyState.rows} paginator onPage={onPage} first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[20, 50]}>
                    <Column field="product_name" style={{ width: '90%' }} />
                    <Column field="action" body={actionBodyTemplate} style={{ width: '10%' }} />
                </DataTable>}
            </div>
        </Sidebar>
        <Sidebar visible={quantitySideBarVisible} position="right" className={`${commonStyle.sidebarmoved} ${commonStyle.shortSideBar} ${!isLargeScreen && 'sidebar-mobile'}`} onHide={() => setQuantitySidebarVisible(false)}>
            <div>
                <NumberInput
                    label="Кількість"
                    value={selectedProduct?.total_quantity ?? 0}
                    onChange={(val) => setSelectedProductQuantity(val)}
                    customStyle="w-full"
                    mandatory
                />
                <CurrencyAmountInput
                    amount={selectedProduct?.price}
                    currency={selectedProduct?.currency}
                    onCurrencyChange={(val) => setSelectedProductCurrency(val)}
                    onAmountChange={(val) => setSelectedProductPrice(val)}
                    customStyle="w-full"
                />
            </div>
            <div>
                <Button label="Додати" severity="success" type="button" onClick={() => { AddProductToAct(selectedProduct) }} className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} autoFocus />
            </div>
        </Sidebar>
    </form>)
}

export default DistributorReturnDetails